// src/icons/HeartRangeMetricIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function HeartRangeMetricIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M11.25 1.5625C11.25 0.699555 11.9496 0 12.8125 0C13.6754 0 14.375 0.699555 14.375 1.5625V14.6875C14.375 15.5504 13.6754 16.25 12.8125 16.25C11.9496 16.25 11.25 15.5504 11.25 14.6875V1.5625Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M7.1875 3.75C6.32455 3.75 5.625 4.44955 5.625 5.3125V18.4375C5.625 19.3004 6.32455 20 7.1875 20C8.05044 20 8.75 19.3004 8.75 18.4375V5.3125C8.75 4.44955 8.05044 3.75 7.1875 3.75Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1.5625 6.875C0.699555 6.875 0 7.57455 0 8.4375V12.8125C0 13.6754 0.699555 14.375 1.5625 14.375C2.42544 14.375 3.125 13.6754 3.125 12.8125V8.4375C3.125 7.57455 2.42544 6.875 1.5625 6.875Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M18.4375 5C17.5746 5 16.875 5.69955 16.875 6.5625V12.1875C16.875 13.0504 17.5746 13.75 18.4375 13.75C19.3004 13.75 20 13.0504 20 12.1875V6.5625C20 5.69955 19.3004 5 18.4375 5Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  HeartRangeMetricIcon
};
//# sourceMappingURL=HeartRangeMetricIcon.mjs.map